import {Component} from "@angular/core";
import {ProductLineEntityModel} from "../../product-line/product-line-entity.model";
import {EditService} from "../../../framework/entity/edit/edit-page/edit.service";
import {EntityModel} from "@fedeltapointofsale/data-client";
import {AbstractSellableData} from "../sellable.data";

@Component({
    selector: "wbo-sellable-edit-imagery",
    templateUrl: "./sellable-edit-imagery.component.html"
})
export class SellableEditImageryComponent {
    constructor(public model: EntityModel<AbstractSellableData<any>>, public editService: EditService) {
    }
}
